import { Component, input, viewChild } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MtrInput, MtrInputModule } from '@mortar/angular/components/atomic/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MtrAutocompleteModule } from '@mortar/angular/components/atomic/autocomplete';
import { DateTime } from 'luxon';

import { InputComponent } from 'app/driver-pay/persistence/core/components/inputs/InputComponent';

@Component({
  selector: 'instant-as-local-datetime-input',
  standalone: true,
  template: `
    <mtr-form-field>
      <input
        #inputElement
        mtr-input
        id="{{ id() }}"
        [value]="initialValue()"
        (change)="handleChange()"
        type="datetime-local" />
    </mtr-form-field>
  `,
  imports: [MtrFormFieldModule, MtrInputModule, MtrAutocompleteModule, FormsModule, ReactiveFormsModule],
})
export class InstantAsLocalDatetimeInputComponent implements InputComponent {
  inputFormControl = input.required<FormControl<string> | FormControl<string | null>>();
  id = input.required<string>();
  inputElement = viewChild<MtrInput>('inputElement');

  handleChange = () => {
    const inputElement = this.inputElement();
    if (inputElement) {
      const localDatetime = new Date(inputElement.value);
      const luxonDateTime = DateTime.fromISO(localDatetime.toISOString());
      if (luxonDateTime.isValid) {
        this.inputFormControl().setValue(luxonDateTime.toString());
      }
    }
  };

  initialValue = () => {
    const inputValue = this.inputFormControl().getRawValue();
    if (inputValue) {
      return DateTime.fromISO(inputValue).toLocal().toFormat("yyyy-MM-dd'T'HH:mm:ss");
    }
    return '';
  };
}
